module.exports = __webpack_public_path__ + "media/images/icons/filled/save-e419dd9510505695585bfcafbd8a3992.svg";